import { render, staticRenderFns } from "./CoverIndexView.vue?vue&type=template&id=2c4bbda4&scoped=true&"
import script from "./CoverIndexView.vue?vue&type=script&lang=js&"
export * from "./CoverIndexView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4bbda4",
  null
  
)

export default component.exports